import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "hooks/useAuth";

const hasStoredAuth = () => {
  const token = localStorage.getItem("authToken");
  const user = localStorage.getItem("authUser");
  return !!token && !!user;
};

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const { session, loading } = useAuth();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const user = localStorage.getItem("authUser");

    if (!token || !user) {
      window.dispatchEvent(new CustomEvent("auth:logout"));
    }
  }, [location.pathname]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!session?.token || !hasStoredAuth()) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace state={{ from: location }} />;
  }

  return children;
}
